import { render, staticRenderFns } from "./helpCenterMenus.vue?vue&type=template&id=239ceb5f&scoped=true&"
import script from "./helpCenterMenus.vue?vue&type=script&lang=js&"
export * from "./helpCenterMenus.vue?vue&type=script&lang=js&"
import style0 from "./helpCenterMenus.vue?vue&type=style&index=0&id=239ceb5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239ceb5f",
  null
  
)

export default component.exports